// removed by extract-text-webpack-plugin
module.exports = {"container":"_1gOt","wrapper":"_1qtK","logo":"_27oV","textLogo":"_3LB7","info":"_13R-","textContainer":"_2Y_u","summaryTitle":"BKEO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/CompanyInformation/styles.scss
// module id = 528
// module chunks = 0